import {
  PayPalButtons,
  PayPalButtonsComponentProps,
  PayPalScriptProvider,
  ReactPayPalScriptOptions,
  usePayPalScriptReducer,
} from "@paypal/react-paypal-js";
import {
  captureOrder,
  getClientID,
  getOrderID,
} from "../../services/paypal.service";
import { useEffect, useState } from "react";
import { CourseRegistrationDTO } from "../../interfaces/course-registration.interface";
import { message, Spin } from "antd";

interface Props {
  setSummary: (payMethod: string, link: string) => void;
  data: CourseRegistrationDTO;
}

function LoadScriptHandler() {
  const [{ isResolved }] = usePayPalScriptReducer();
  return !isResolved ? <Spin /> : <></>;
}

export default function PayPalPayment(props: Props) {
  const [initialOptions, setInitialOptions] =
    useState<ReactPayPalScriptOptions>();

  const createOrder: PayPalButtonsComponentProps["createOrder"] = () => {
    return getOrderID(props.data).then((data) => {
      if (data.success) {
        return data.orderID ?? "";
      } else {
        message.error(
          "There has been an error with your order, please tray again",
        );
        return "";
      }
    });
  };

  const onApprove: PayPalButtonsComponentProps["onApprove"] = (data) => {
    return captureOrder(data.orderID, props.data).then((registrationData) => {
      try {
        if (registrationData.success) {
          message.success("Your payment has been successfully processed");
          props.setSummary("Paypal", "");
        } else {
          if (
            registrationData?.error === "DECLINED" ||
            registrationData?.error === "INSTRUMENT_DECLINED"
          ) {
            message.error(
              "Your payment method has been declined, please try again",
            );
          } else {
            message.error(
              "There has been an error processing your payment, please tray again",
            );
          }
        }
      } catch (error) {
        message.error("There has been an unexpected error, please tray again");
      }
    });
  };

  const onCancel: PayPalButtonsComponentProps["onCancel"] = () => {
    message.error("The payment has been cancelled, please tray again");
  };

  const onError: PayPalButtonsComponentProps["onError"] = () => {
    message.error(
      "There has been an error processing your payment, please tray again",
    );
  };

  useEffect(() => {
    getClientID().then((clientID) => {
      setInitialOptions({
        clientId: clientID ?? "",
        currency: "CAD",
        disableFunding: "card",
      });
    });
  }, []);

  return (
    <div id="paypalButtons">
      {initialOptions ? (
        <PayPalScriptProvider options={initialOptions} deferLoading={false}>
          <LoadScriptHandler />
          <PayPalButtons
            style={{
              shape: "rect",
              layout: "vertical",
              color: "gold",
              label: "paypal",
            }}
            createOrder={createOrder}
            onApprove={onApprove}
            onCancel={onCancel}
            onError={onError}
          />
        </PayPalScriptProvider>
      ) : (
        <Spin />
      )}
    </div>
  );
}
